import { render, staticRenderFns } from "./SalesGroup.vue?vue&type=template&id=4028e672&scoped=true"
import script from "./SalesGroup.vue?vue&type=script&lang=js"
export * from "./SalesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4028e672",
  null
  
)

export default component.exports